import { g as r } from "../../utils-BOfnFgIH.js";
import { I as l } from "../../constants-DeVuDy8J.js";
import { openBlock as d, createElementBlock as o, normalizeClass as s, createElementVNode as a } from "vue";
import { _ as c } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const u = {
  name: "DtIconPhoneHangUp",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(l).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return l[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = r();
  }
}, p = ["aria-label", "data-qa", "aria-hidden"], m = ["clip-path"], f = ["id"];
function h(e, t, n, _, g, i) {
  return d(), o("svg", {
    "aria-label": n.ariaLabel,
    class: s([i.iconSizeClass, "d-icon d-icon--phone-hang-up"]),
    "data-qa": i.dataQA,
    "aria-hidden": i.ariaHidden,
    role: "img",
    "data-name": "Phone Hang Up",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [
    a("g", {
      "clip-path": `url(#${e.uniqueID}a)`
    }, [...t[0] || (t[0] = [
      a("path", {
        fill: "currentColor",
        "fill-rule": "evenodd",
        d: "M.538 4.006c.84-.668 2.864-2.005 5.62-2.004a8.003 8.003 0 0 1 5.358 2.032c.446.404.396 1.054.017 1.433l-.353-.354.353.354-.726.726c-.339.34-.866.404-1.277.157l-1.076-.646a1.045 1.045 0 0 1-.503-.99l.131-1.45a7.117 7.117 0 0 0-1.924-.262 7.61 7.61 0 0 0-2.096.296v1.49c.001.367-.191.708-.506.897l-1.109.666-.257-.429.257.429a1.045 1.045 0 0 1-1.277-.157l-.701-.701C.066 5.09.045 4.397.538 4.006Zm2.524-.35c-.858.37-1.506.82-1.891 1.124a.047.047 0 0 0 .005.006l.701.7a.045.045 0 0 0 .055.008l1.109-.667a.045.045 0 0 0 .022-.038V3.655Zm5.992-.04-.107 1.188a.045.045 0 0 0 .022.043l1.076.646c.018.01.04.007.055-.007l.726-.726a6.895 6.895 0 0 0-1.772-1.144ZM6 6.237a.5.5 0 0 1 .5.5v2.41l.955-.955a.5.5 0 1 1 .707.707l-1.808 1.808a.5.5 0 0 1-.707 0L3.839 8.899a.5.5 0 1 1 .707-.707l.954.954V6.737a.5.5 0 0 1 .5-.5Z",
        "clip-rule": "evenodd"
      }, null, -1)
    ])], 8, m),
    a("defs", null, [
      a("clipPath", {
        id: `${e.uniqueID}a`
      }, [...t[1] || (t[1] = [
        a("path", {
          fill: "#fff",
          d: "M0 0h12v12H0z"
        }, null, -1)
      ])], 8, f)
    ])
  ], 10, p);
}
const S = /* @__PURE__ */ c(u, [["render", h]]);
export {
  S as default
};
//# sourceMappingURL=phone-hang-up.js.map
